module.exports = __webpack_public_path__ + "static/finovate-topleass-atm-2014-f9b779c15cd6842cc0cb592707ab55ff.png";